module.exports = __webpack_public_path__ + "img/back.676605db.png";